/**
 * 号码包管理页面
 */
export default {
  dbl_number_package_title: "User ID",
  dbl_number_package_extract: "Extract Number Package",
  dbl_number_package_upload: "Upload Number Package",
  dbl_number_package_name: "Package Name",
  dbl_number_package_name_placeholder: "Please enter the package name",
  dbl_number_package_type: "Package Type",
  dbl_number_package_static: "Static",
  dbl_number_package_dynamic: "Dynamic",
  dbl_number_package_extracted_fields: "Extracted Fields",
  dbl_number_package_extracted_fields_placeholder: "Please select extracted fields",
  dbl_number_package_size: "Package Size",
  dbl_number_package_note: "Note",
  dbl_number_package_status: "Status",
  dbl_number_package_ready: "Ready",
  dbl_number_package_abnormal: "Abnormal",
  dbl_number_package_extracting: "Extracting",
  dbl_number_package_pending: "undetermined",
  dbl_number_package_creation_time: "Creation Time",
  dbl_number_package_creator: "Creator",
  dbl_number_package_operation: "Actions",
  dbl_number_package_analyze: "Analyze",
  dbl_number_package_edit: "Edit",
  dbl_number_package_remarks: "Package Remarks (Optional)",
  dbl_number_package_remarks_placeholder: "Please enter the package remarks",
  dbl_number_package_total: "Total {total} Items",
  dbl_number_package_search: "Search by package name or note",
  dbl_number_package_not_empty: "Package name cannot be empty",
  dbl_number_package_save: "Save",
  dbl_number_package_cancel: "Cancel",
  dbl_number_package_save_success: "Save {name} success",

};